import BlockRender from '@/utils/transaction/template-editor/component/block-render';
import { BlockProps } from '@/utils/transaction/template-editor/component/content-blocks/type';
// src\assets\images\gahana-stores-footer.jpg

import {
  PrintPreferenceProps,
  TemplateEditorConfigProps,
} from '@/utils/transaction/template-editor/type';
import React from 'react';
// import {
//   ImageProps,
//   WaterMarkProps,
// } from 'services/userManagement/organization/type';
// import { isColorWatermark, isImageWatermark } from "services/userManagement/organization/type-guard";

interface Props {
  config: TemplateEditorConfigProps;
  headerImage?: any;
  footerImage?: any;
  watermark?: any;
  headerBlocks: BlockProps[];
  footerBlocks: BlockProps[];
  contentBlock: React.ReactNode;
  contentX: number;
  contentY: number;
  suffix?: React.ReactNode | null;
  totalPages: number;
}

export const PageRender: React.FC<Props> = (props) => {
  const { headerImage, footerImage, watermark, suffix, totalPages = 1 } = props;
  const {
    headerBlocks,
    footerBlocks,
    contentBlock,
    contentX,
    contentY,
    config,
  } = props;
  const { height, width, header, footer, margin } = config;

  const headerImageHeight = headerImage
    ? (width / headerImage.width) * headerImage.height
    : 0;
  const footerImageHeight = footerImage
    ? (width / footerImage.width) * footerImage.height
    : 0;
  const headerHeight = header?.isEnabled
    ? header.height + headerImageHeight
    : headerImageHeight;
  const footerHeight = footer?.isEnabled
    ? footer.height + footerImageHeight
    : footerImageHeight;
  const footerStart = height - footerHeight;
  const availableWidth = width - margin?.left - margin?.right;
  // Watermark opacity should be decreased by the factor of page length; as the watermark's stack for every page
  // const watermarkOpacity =
  //   (config.watermark?.opacity ?? 0) * (0.01 / totalPages);

  const watermarkOpacity =
    (config.watermark?.opacity ?? 0) * (0.02 / totalPages);

  const defaultPrintPreference: PrintPreferenceProps = {
    printWithImage: false,
    isMarginEnabled: false,
  };

  const printPreference = config?.printPreference ?? defaultPrintPreference;

  return (
    <div
      style={{
        minHeight: config.height - 19,
        maxWidth: config.width,
        width: config.width,
        pageBreakAfter: 'always',
        ...(printPreference.isFooterFixed && { position: 'relative' }),
        // backgroundColor:
        //   watermark &&
        //   // isColorWatermark(watermark) &&
        //   config.printPreference?.printWithImage
        //     ? watermark.name
        //     : 'white',
        backgroundColor: 'white',
        fontFamily: 'Poppins',
        // position: 'relative',
      }}
    >
      {/* <style>
        {`
            @page {
    size: auto;
    margin: 0.22cm;
    @bottom-right {
      content: "Page: " counter(page) " of " counter(pages);
      font-size: 9px;
      color: #000000;
    }
  }
            `}
      </style> */}

      {
        watermark && watermark?.name && printPreference.printWithImage && (
          // isImageWatermark(watermark) && (
          <div
            style={{
              position: 'fixed',
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              width: `${width}px`,
              // height: `${watermark.height}px`,
              height: `${(width / watermark.width) * watermark.height}px`,
              backgroundImage: `url(${watermark.name})`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              opacity: watermarkOpacity,
            }}
          />
        )
        // )
      }

      <table style={{ width: width }}>
        <thead
          style={{
            width: '100%',
          }}
        >
          <tr>
            <td
              style={{
                // height:
                //   printPreference.isFooterFixed && !suffix
                //     ? headerHeight - 19
                //     : footer?.isEnabled && footerImage && !suffix
                //       ? headerHeight + 25
                //       : headerHeight,
                height: headerHeight,
                width: '100%',
                position: 'relative',
              }}
            >
              {header?.isEnabled &&
                headerImage &&
                printPreference.printWithImage && (
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: headerImage.width,
                      height: headerImage.height,
                      zIndex: 0,
                      backgroundImage: `url("${headerImage?.name}")`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      transform: `scale(${width / headerImage.width})`,
                      transformOrigin: 'top left',
                    }}
                  />
                )}
              {headerBlocks.map((block) => (
                <div
                  key={block.key}
                  style={{
                    left: `${block.x}px`,
                    top: `${block.y}px`,
                    boxSizing: 'border-box',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                    position: 'absolute',
                    display: block.isVisible ? 'block' : 'none',
                  }}
                >
                  <BlockRender block={block} maxWidth={width} />
                </div>
              ))}
            </td>
          </tr>
        </thead>

        <tfoot
          style={{
            width: '100%',
          }}
        >
          <tr>
            <td
              style={{
                height: footerHeight,
                width: width,
                position: 'relative',
              }}
            >
              {footerBlocks.map((block) => (
                <div
                  key={block.key}
                  style={{
                    left: `${block.x}px`,
                    top: `${block.y - footerStart}px`,
                    boxSizing: 'border-box',
                    whiteSpace: 'nowrap',
                    textAlign: 'center',
                    position: 'absolute',
                    display: block.isVisible ? 'block' : 'none',
                  }}
                >
                  <BlockRender block={block} maxWidth={width} />
                </div>
              ))}
            </td>
          </tr>
        </tfoot>

        <tbody
          style={
            {
              // minHeight: `${config?.height - contentY - footerHeight}px`,
              // maxHeight: `100%`,
              // verticalAlign: 'top',
            }
          }
        >
          <tr>
            <td>
              <div
                style={{
                  paddingLeft: `${contentX}px`,
                  paddingTop: contentY - headerHeight,
                  // paddingTop: Math.max(contentY - headerHeight, 0),
                  boxSizing: 'border-box',
                  paddingBottom: 'auto',
                  whiteSpace: 'nowrap',
                  textAlign: 'center',
                }}
              >
                {contentBlock}
              </div>
            </td>
          </tr>

          {/* {suffix && (
            <tr>
              <td
                className={`tw-overflow-clip tw-max-w-[${availableWidth}]`}
                style={{ position: 'relative', zIndex: 2 }}
              >
                {suffix}
              </td>
            </tr>
          )} */}
        </tbody>
      </table>

      {footer?.isEnabled && footerImage && printPreference.printWithImage && (
        <div
          style={{
            // position:'fixed',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: footerImage.width,
            height: footerImage.height,
            zIndex: 0,
            backgroundImage: `url("${footerImage.name}")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            transform: `scale(${width / footerImage.width})`,
            transformOrigin: 'bottom left',
          }}
        />
      )}
    </div>
  );
};
